import { AnnotationsRenderer } from "@/components/r3f/renderers/annotations/annotations-renderer";
import { JSX } from "react";
import { AnnotationDispatch } from "../data-dispatch/use-dispatch-annotations";
import { useToolsAcquaintance } from "../tools/tools-acquaintance-context";

type FlyWalkAnnotationsRendererProps = {
  /** An object containing the annotations dispatched for fly walk mode */
  annotations: AnnotationDispatch;
  /**
   * Whether the camera is flying to an image. Pano-local annotations are placed around the pano center,
   * so they only match the pano image once the camera has reached it.
   */
  isAnimatingToImage: boolean;
};

/** @returns A component to render the annotations dispatched for fly walk mode */
export function FlyWalkAnnotationsRenderer({
  annotations,
  isAnimatingToImage,
}: FlyWalkAnnotationsRendererProps): JSX.Element | null {
  const { clippingPlanes, activeToolAndPicking } = useToolsAcquaintance();

  if (activeToolAndPicking.isPickingToolActive) {
    return null;
  }

  return (
    <>
      {/** Annotations should be visible only when tools are disabled */}
      {/* The annotations which are local to the panorama and they should not be collapsed */}
      {!isAnimatingToImage && (
        <AnnotationsRenderer
          annotations={annotations.notCollapsibleAnnotations}
          worldTransform={annotations.panoAdjustedPose}
          preventCollapse
        />
      )}
      {(!annotations.isPano ||
        (annotations.isPanoAligned &&
          (annotations.isPanoWithDepth ||
            annotations.isPanoPairedWithPickingPointCloud))) && (
        // Visible only if the pano has a correct rotation, or if we are rendering pointcloud/CAD model
        // Do not show area annotations for a pano without depth info
        // Annotation that are created in the nearby area of the panorama, which needs to be collapsed if they are far away
        <AnnotationsRenderer
          annotations={annotations.annotations}
          worldTransform={annotations.panoAdjustedPose}
          clippingPlanes={clippingPlanes}
        />
      )}
    </>
  );
}
